import { render } from "./NewInvoicePage.vue?vue&type=template&id=1141bb6e&scoped=true"
import script from "./NewInvoicePage.vue?vue&type=script&lang=js"
export * from "./NewInvoicePage.vue?vue&type=script&lang=js"

import "./NewInvoicePage.vue?vue&type=style&index=0&id=1141bb6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1141bb6e"]])

export default __exports__